// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/plan_submission.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/plan_submission.proto.
 */
export const file_bfftypes_v1_plan_submission: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum bfftypes.v1.PlanSubmissionKind
 */
export enum PlanSubmissionKind {
  /**
   * @generated from enum value: PLAN_SUBMISSION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_SUBMISSION_KIND_GENERATION_SALE = 1;
   */
  GENERATION_SALE = 1,

  /**
   * @generated from enum value: PLAN_SUBMISSION_KIND_DEMAND_PROCUREMENT = 2;
   */
  DEMAND_PROCUREMENT = 2,

  /**
   * @generated from enum value: PLAN_SUBMISSION_KIND_DR = 3;
   */
  DR = 3,
}

/**
 * Describes the enum bfftypes.v1.PlanSubmissionKind.
 */
export const PlanSubmissionKindSchema: GenEnum<PlanSubmissionKind> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 0);

/**
 * PlanSubmissionDownloadFormat is the file format of a plan submission download.
 *
 * @generated from enum bfftypes.v1.PlanSubmissionDownloadFormat
 */
export enum PlanSubmissionDownloadFormat {
  /**
   * XML として扱う (既存 caller 互換)
   *
   * @generated from enum value: PLAN_SUBMISSION_DOWNLOAD_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_SUBMISSION_DOWNLOAD_FORMAT_XML = 1;
   */
  XML = 1,

  /**
   * XML 1 entry を ZIP 圧縮
   *
   * @generated from enum value: PLAN_SUBMISSION_DOWNLOAD_FORMAT_ZIP = 2;
   */
  ZIP = 2,
}

/**
 * Describes the enum bfftypes.v1.PlanSubmissionDownloadFormat.
 */
export const PlanSubmissionDownloadFormatSchema: GenEnum<PlanSubmissionDownloadFormat> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 1);

/**
 * PlanTimeframe identifies the planning horizon of a plan submission.
 * Hosted under bfftypes/v1 because the enum is reused across multiple
 * BFF service packages.
 *
 * Wire values mirror backend types.v1.PlanTimeframe but the enum is kept
 * BFF-local so that BFF's contract with the frontend stays decoupled from
 * backend internal types.
 *
 * @generated from enum bfftypes.v1.PlanTimeframe
 */
export enum PlanTimeframe {
  /**
   * @generated from enum value: PLAN_TIMEFRAME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_TIMEFRAME_TODAY = 1;
   */
  TODAY = 1,

  /**
   * @generated from enum value: PLAN_TIMEFRAME_TOMORROW = 2;
   */
  TOMORROW = 2,

  /**
   * @generated from enum value: PLAN_TIMEFRAME_DAY_AFTER_TOMORROW = 3;
   */
  DAY_AFTER_TOMORROW = 3,

  /**
   * @generated from enum value: PLAN_TIMEFRAME_WEEKLY = 4;
   */
  WEEKLY = 4,

  /**
   * @generated from enum value: PLAN_TIMEFRAME_MONTHLY = 5;
   */
  MONTHLY = 5,

  /**
   * @generated from enum value: PLAN_TIMEFRAME_ANNUAL = 6;
   */
  ANNUAL = 6,
}

/**
 * Describes the enum bfftypes.v1.PlanTimeframe.
 */
export const PlanTimeframeSchema: GenEnum<PlanTimeframe> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 2);

/**
 * PlanSubmissionStatus represents the processing status of a plan submission
 * as reported by the OCCTO portal.
 *
 * Wire values mirror backend types.v1.PlanSubmissionStatus but the enum is
 * kept BFF-local so that BFF's contract with the frontend stays decoupled
 * from backend internal types. UI badge derivation (未提出 / 編集中 / etc.)
 * is performed in the frontend from the raw status + version + timestamps.
 *
 * @generated from enum bfftypes.v1.PlanSubmissionStatus
 */
export enum PlanSubmissionStatus {
  /**
   * @generated from enum value: PLAN_SUBMISSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 生成済み (未提出)
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_GENERATED = 1;
   */
  GENERATED = 1,

  /**
   * 生成失敗
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_GENERATION_FAILED = 2;
   */
  GENERATION_FAILED = 2,

  /**
   * 提出済み
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_SUBMITTED = 3;
   */
  SUBMITTED = 3,

  /**
   * 受理済み
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_ACCEPTED = 4;
   */
  ACCEPTED = 4,

  /**
   * 差し戻し
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_REJECTED = 5;
   */
  REJECTED = 5,

  /**
   * 不整合
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_INCONSISTENT = 6;
   */
  INCONSISTENT = 6,

  /**
   * 編集中 (draft が永続化されている状態)
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_EDITING = 7;
   */
  EDITING = 7,

  /**
   * 生成中 (worker が非同期処理中の in-progress 状態)
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_GENERATING = 8;
   */
  GENERATING = 8,

  /**
   * 処理中 (提出 enqueue 済み、worker の OCCTO put 完了待ち)
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_SUBMITTING = 9;
   */
  SUBMITTING = 9,

  /**
   * 提出失敗 (提出起因): put の非フォーマット permanent 失敗。XML は生成済み
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_SUBMIT_FAILED = 10;
   */
  SUBMIT_FAILED = 10,

  /**
   * 承認待ち (承認完了後に OCCTO へ enqueue)
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_APPROVAL_PENDING = 11;
   */
  APPROVAL_PENDING = 11,

  /**
   * 送信失敗: OCCTO の回数制限、または復旧・retry 履歴のない初回送信の提出期限経過で終端
   *
   * @generated from enum value: PLAN_SUBMISSION_STATUS_SEND_FAILED = 12;
   */
  SEND_FAILED = 12,
}

/**
 * Describes the enum bfftypes.v1.PlanSubmissionStatus.
 */
export const PlanSubmissionStatusSchema: GenEnum<PlanSubmissionStatus> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 3);

/**
 * PlanSourceType is the trade / market source of a plan sales or procurement
 * breakdown row (発電販売 / 需要調達 計画の販売・調達内訳のソース種別).
 *
 * Wire values mirror backend types.v1.PlanSourceType but the enum is kept
 * BFF-local so that BFF's contract with the frontend stays decoupled from
 * backend internal types.
 *
 * The set of values is provisional: the column composition of the 調達/販売
 * 内訳 is still unconfirmed in procurement-plan.md §316, tracked as
 * residual issue #890.
 *
 * @generated from enum bfftypes.v1.PlanSourceType
 */
export enum PlanSourceType {
  /**
   * @generated from enum value: PLAN_SOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * BG 相対 (相対取引のカウンターパーティ BG)
   *
   * @generated from enum value: PLAN_SOURCE_TYPE_BG_BILATERAL = 1;
   */
  BG_BILATERAL = 1,

  /**
   * eClear (enechain の取引プラットフォーム経由の相対)
   *
   * @generated from enum value: PLAN_SOURCE_TYPE_E_CLEAR = 2;
   */
  E_CLEAR = 2,

  /**
   * JEPX スポット市場
   *
   * @generated from enum value: PLAN_SOURCE_TYPE_JEPX_SPOT = 3;
   */
  JEPX_SPOT = 3,

  /**
   * JEPX 時間前市場
   *
   * @generated from enum value: PLAN_SOURCE_TYPE_JEPX_INTRADAY = 4;
   */
  JEPX_INTRADAY = 4,

  /**
   * 常時バックアップ (常時 BU)
   *
   * @generated from enum value: PLAN_SOURCE_TYPE_CONSTANT_BACKUP = 5;
   */
  CONSTANT_BACKUP = 5,

  /**
   * FIT・FIP
   *
   * @generated from enum value: PLAN_SOURCE_TYPE_FIT_FIP = 6;
   */
  FIT_FIP = 6,

  /**
   * 自己託送
   *
   * @generated from enum value: PLAN_SOURCE_TYPE_SELF_WHEELING = 7;
   */
  SELF_WHEELING = 7,
}

/**
 * Describes the enum bfftypes.v1.PlanSourceType.
 */
export const PlanSourceTypeSchema: GenEnum<PlanSourceType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 4);

/**
 * JepxSpotPortion is the OCCTO sub-classification of a JEPX スポット (前日スポット)
 * 調達内訳行: 調達先未定分 (約定前) と 相対契約分 (相対契約由来). Only 調達側スポットが
 * この 2 区分に分かれる (販売スポット・時間前は区分なし = UNSPECIFIED). 詳細画面が
 * 調達先未定分 / 相対契約分 の 2 列を型付きで振り分ける信号 (= counterparty_name 文字列
 * 照合に依存しない)。Wire values mirror backend types.v1.JepxSpotPortion.
 *
 * @generated from enum bfftypes.v1.JepxSpotPortion
 */
export enum JepxSpotPortion {
  /**
   * 区分なし (= 非 JEPX スポット調達行)
   *
   * @generated from enum value: JEPX_SPOT_PORTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 調達先未定分 (約定前)
   *
   * @generated from enum value: JEPX_SPOT_PORTION_UNDETERMINED = 1;
   */
  UNDETERMINED = 1,

  /**
   * 相対契約分 (相対契約由来)
   *
   * @generated from enum value: JEPX_SPOT_PORTION_BILATERAL = 2;
   */
  BILATERAL = 2,
}

/**
 * Describes the enum bfftypes.v1.JepxSpotPortion.
 */
export const JepxSpotPortionSchema: GenEnum<JepxSpotPortion> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 5);

/**
 * GenerationSaleSubKind discriminates sub-kinds of GENERATION_SALE plan
 * submissions: normal (発電販売), FIT, and FIP. Mirrors backend
 * types.v1.GenerationSaleSubKind. Used by OcctoMasterService's
 * GenerationSalesMaster / GenerationSalesMasterListItem.plan_category
 * (= generation-sales-plan-category 設計書) — a master-side reuse of the
 * same axis as the plan-submission filter.
 *
 * @generated from enum bfftypes.v1.GenerationSaleSubKind
 */
export enum GenerationSaleSubKind {
  /**
   * @generated from enum value: GENERATION_SALE_SUB_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERATION_SALE_SUB_KIND_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: GENERATION_SALE_SUB_KIND_FIT = 2;
   */
  FIT = 2,

  /**
   * @generated from enum value: GENERATION_SALE_SUB_KIND_FIP = 3;
   */
  FIP = 3,
}

/**
 * Describes the enum bfftypes.v1.GenerationSaleSubKind.
 */
export const GenerationSaleSubKindSchema: GenEnum<GenerationSaleSubKind> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 6);

/**
 * PlanConsistencyStatus is the 整合ステータス of one plan list row
 * (docs/specs/plan-submit/plan-common.md §一覧テーブルの「整合ステータス」列,
 * AC-IC-004). Distinct from PlanSubmissionStatus (the OCCTO submission
 * progress). Hosted under bfftypes.v1 because the enum is reused across the
 * procurement-plan and generation-sales-plan list rows.
 *
 * Wire values mirror backend types.v1.PlanConsistencyStatus but the enum is
 * kept BFF-local so that BFF's contract with the frontend stays decoupled
 * from backend internal types. UNSPECIFIED is shown like NOT_EVALUATED by
 * the frontend (never as CONSISTENT).
 *
 * @generated from enum bfftypes.v1.PlanConsistencyStatus
 */
export enum PlanConsistencyStatus {
  /**
   * @generated from enum value: PLAN_CONSISTENCY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_CONSISTENCY_STATUS_CONSISTENT = 1;
   */
  CONSISTENT = 1,

  /**
   * @generated from enum value: PLAN_CONSISTENCY_STATUS_MISMATCH_RESOLVED = 2;
   */
  MISMATCH_RESOLVED = 2,

  /**
   * @generated from enum value: PLAN_CONSISTENCY_STATUS_COUNTERPARTY_MISMATCH = 3;
   */
  COUNTERPARTY_MISMATCH = 3,

  /**
   * @generated from enum value: PLAN_CONSISTENCY_STATUS_CROSS_PLAN_INCONSISTENCY = 4;
   */
  CROSS_PLAN_INCONSISTENCY = 4,

  /**
   * @generated from enum value: PLAN_CONSISTENCY_STATUS_INTERNAL_PLAN_INCONSISTENCY = 5;
   */
  INTERNAL_PLAN_INCONSISTENCY = 5,

  /**
   * @generated from enum value: PLAN_CONSISTENCY_STATUS_NOT_EVALUATED = 6;
   */
  NOT_EVALUATED = 6,
}

/**
 * Describes the enum bfftypes.v1.PlanConsistencyStatus.
 */
export const PlanConsistencyStatusSchema: GenEnum<PlanConsistencyStatus> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_plan_submission, 7);

